import React from "react";
import * as Phosphor from "@phosphor-icons/react";
import { toneColor } from "@/lib/laymen";

/** Plain-language status pill with Phosphor icon + concrete action tip. */
export default function LaymenBadge({ status, size = "md", showTip = true, testid }) {
  const Icon = Phosphor[status?.icon] || Phosphor.Info;
  const c = toneColor(status?.level);
  const pad = size === "lg" ? "px-4 py-3" : "px-3 py-2";
  const iconSize = size === "lg" ? 24 : 18;
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <div
        className={`inline-flex items-start gap-2 rounded-sm w-full ${pad}`}
        style={{ background: c.bg, color: c.fg }}
      >
        <Icon size={iconSize} weight="fill" className="shrink-0 mt-0.5" />
        <div className="flex flex-col leading-tight min-w-0">
          <span className={`${size === "lg" ? "text-sm" : "text-xs"} font-semibold`}>
            {status?.label}
          </span>
          {status?.message && (
            <span className="text-[11px] font-normal opacity-85 mt-0.5 leading-snug">
              {status.message}
            </span>
          )}
        </div>
      </div>
      {showTip && status?.tip && (
        <div className="flex items-start gap-1.5 text-[11px] text-zinc-400 leading-snug pl-0.5">
          <Phosphor.ArrowRight size={12} weight="bold" className="mt-0.5 shrink-0" style={{ color: c.dot }} />
          <span><strong className="font-medium text-white">Tipp:</strong> {status.tip}</span>
        </div>
      )}
    </div>
  );
}
